import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      En stelplena nokto la sableroj rigardas al ĉielo kiel al spegulo, kaj ĉiu el ili facile trovas sin inter la stelaro.
    </p>
    
    <p class="mb-3">
      Endas nur trovi la brilantan stelon kaj kompreni, ke vi simple rigardas al la spegulo…
    </p>
    `
  )
}

const itemName = {
  esp: 'Steloj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;